import FrequencyText from 'common/components/clubMembership/FrequencyText';

const Frequency = (props) => {
  const { clubMembership } = props;
  return (
    <span className="c7-account__subscription_frequency">
      <strong>Frequency</strong>
      <br />
      <FrequencyText frequency={clubMembership.subscription.frequency} />
    </span>
  );
};

export default Frequency;
